import { SITE, TERMS_UPDATED } from './siteInfo';
import Fill from './Fill';

// תנאי השימוש (/terms). נוסח סטנדרטי - מומלץ שעורך דין יעבור עליו לפני פרסום.
// שינוי מהותי → לעדכן את TERMS_VERSION ו-TERMS_UPDATED ב-siteInfo.js (משתמשים קיימים יתבקשו לאשר מחדש).
const TermsOfUse = ({ titleStyle, updatedStyle }) => (
  <>
    <h1 style={titleStyle}>תנאי שימוש</h1>
    <p style={updatedStyle}>עודכן לאחרונה: {TERMS_UPDATED}</p>

    <p>
      ברוכים הבאים ל"{SITE.name}" (להלן: "האתר" או "השירות"), בכתובת {SITE.url}. השימוש באתר, בכל דרך ובכל מכשיר, מהווה הסכמה לתנאים אלה
      ולמדיניות הפרטיות. אם אינך מסכים/ה לתנאים - אין להשתמש באתר. התנאים מנוסחים בלשון זכר מטעמי נוחות בלבד ומתייחסים לכל המגדרים.
    </p>

    <h2>1. מהות השירות</h2>
    <p>
      1.1. האתר הוא כלי עזר חינמי להשוואת מחירים של מוצרים בין חנויות ורשתות מזון (למשל סופרמרקטים בכפר חב"ד וברשתות נוספות).
      האתר מציג מידע שנאסף מאתרי האינטרנט הפומביים של החנויות, וכן מידע שמוסיפים משתמשים.
    </p>
    <p>
      1.2. האתר <strong>אינו חנות</strong>, אינו מוכר מוצרים, אינו גובה תשלום ואינו צד לכל עסקה בין המשתמש לבין חנות כלשהי.
      ההחלטה אם, מה, מתי ואיפה לקנות היא של המשתמש בלבד.
    </p>
    <p>
      1.3. האתר אינו קשור לחנויות או לרשתות המוצגות בו, אינו מייצג אותן ואינו פועל מטעמן, אלא אם נאמר במפורש אחרת.
      שמות החנויות, הרשתות, המותגים והמוצרים, וכן הסימנים המסחריים שלהם, שייכים לבעליהם ומוצגים לצורך זיהוי בלבד.
    </p>

    <h2>2. המידע באתר - ללא אחריות לדיוק</h2>
    <p>
      2.1. המחירים, המבצעים, שמות המוצרים, תמונותיהם ופרטיהם נאספים מאתרי החנויות באופן אוטומטי ובמועדים מסוימים בלבד
      (בדרך כלל פעם ביום), ולכן <strong>ייתכן שאינם מעודכנים, שלמים או מדויקים</strong>. מחירים ומבצעים משתנים לעתים קרובות,
      עשויים להיות שונים בין סניפים, בין קנייה בחנות לבין הזמנה באתר, ולהיות כפופים לתנאים (כמות, מועד, מלאי, כרטיס מועדון ועוד).
    </p>
    <p>
      2.2. <strong>המחיר המחייב הוא המחיר בחנות או באתר החנות בעת הקנייה.</strong> יש לבדוק את המחיר מול החנות לפני הקנייה.
    </p>
    <p>
      2.3. התאמת מוצרים בין חנויות נעשית באופן ממוחשב ועלולה לכלול טעויות (למשל מוצר דומה אך לא זהה, גודל אריזה שונה).
      תמונות המוצרים להמחשה בלבד.
    </p>
    <p>
      2.4. חישובים באתר - כגון "הכי זול", הפרשי מחירים, סכום רשימת קניות או "חיסכון" - הם הערכה בלבד לפי המידע שבאתר,
      ואינם כוללים בהכרח דמי משלוח, מינימום הזמנה, הנחות אישיות או מבצעים מותנים.
    </p>
    <p>
      2.5. המידע באתר אינו מהווה המלצה, ייעוץ או הצעה לקנות מוצר כלשהו, ואינו מחליף בדיקה עצמאית.
    </p>

    <h2>3. הגבלת אחריות</h2>
    <p>
      3.1. השירות ניתן כמות שהוא (AS IS) וכפי שהוא זמין (AS AVAILABLE), ללא תמורה וללא כל מצג או התחייבות, מפורשים או משתמעים,
      לגבי דיוק המידע, שלמותו, עדכניותו, התאמתו לצורך מסוים או זמינות השירות.
    </p>
    <p>
      3.2. במידה המרבית המותרת לפי דין, המפעיל, מי מטעמו ומי שמסייע בהפעלת האתר לא יישאו בכל אחריות לכל נזק, הפסד, הוצאה או
      אובדן - ישיר או עקיף, כספי או אחר - שייגרמו למשתמש או לצד שלישי בקשר לשימוש באתר, להסתמכות על מידע שבו, לקנייה שבוצעה
      או לא בוצעה בעקבותיו, לטעות במחיר או בפרטי מוצר, לתקלה, להפסקת שירות או לאובדן מידע (כגון רשימת קניות או מועדפים).
    </p>
    <p>
      3.3. האתר אינו אחראי למוצרים עצמם - לאיכותם, לבטיחותם, לכשרותם, לרכיביהם, לתאריכי התפוגה, למלאי או לשירות של החנויות.
      כל טענה בעניינים אלה תופנה לחנות או ליצרן בלבד. מידע על כשרות, אלרגנים ורכיבים יש לבדוק על גבי המוצר עצמו.
    </p>

    <h2>4. חשבון משתמש</h2>
    <p>
      4.1. חלק מהשירותים (רשימת קניות, מועדפים, עדכון מחיר, שליחת פידבק) דורשים הרשמה. יש למסור פרטים נכונים ולשמור על
      סודיות הסיסמה. המשתמש אחראי לכל פעולה שנעשית בחשבונו.
    </p>
    <p>
      4.2. המפעיל רשאי לאשר או לדחות בקשת הרשמה, ולחסום או למחוק חשבון - לפי שיקול דעתו, ובפרט במקרה של הפרת התנאים,
      מסירת פרטים כוזבים או שימוש לרעה.
    </p>
    <p>
      4.3. רשימת קניות משותפת: מי שמצטרף לרשימה דרך קישור הזמנה רואה את הרשימה, יכול לערוך אותה ורואה את השמות של שאר
      המשתתפים. יש לשתף קישור הזמנה רק עם אנשים שרוצים לשתף איתם את הרשימה.
    </p>
    <p>4.4. השימוש באתר מיועד לבני 18 ומעלה, או לקטינים בהסכמת הורה או אפוטרופוס.</p>

    <h2>5. תוכן שמוסיפים משתמשים</h2>
    <p>
      5.1. משתמשים יכולים לעדכן מחירים ולשלוח פידבק. המשתמש אחראי לתוכן שהוא מוסיף ומצהיר שהוא נכון ככל הידוע לו,
      ושאינו פוגע, מטעה, מפר זכויות של אחרים או מנוגד לדין.
    </p>
    <p>
      5.2. עדכון מחיר על ידי משתמש מוצג באתר עם סימון "עודכן ע"י משתמש". המפעיל אינו בודק כל עדכון ואינו אחראי לנכונותו,
      ורשאי לערוך, להסתיר או למחוק כל תוכן, בלי הודעה מוקדמת.
    </p>
    <p>
      5.3. בהוספת תוכן המשתמש מעניק למפעיל רישיון חינם, לא בלעדי ובלתי מוגבל בזמן, להציג את התוכן באתר ולהשתמש בו
      לצורך הפעלת השירות ושיפורו.
    </p>

    <h2>6. שימושים אסורים</h2>
    <p>אין להשתמש באתר באופן שמנוגד לדין או לתנאים אלה, ובכלל זה אין:</p>
    <ul>
      <li>לאסוף, להעתיק או לשלוף מידע מהאתר באופן אוטומטי או המוני (רובוטים, סקריפטים, scraping), או להשתמש בו לצורך מסחרי, בלי אישור בכתב;</li>
      <li>לפגוע או לנסות לפגוע בפעילות האתר, באבטחתו או בשרתים שלו, או לעקוף מנגנוני הרשאה;</li>
      <li>להתחזות לאחר, לפתוח חשבונות כוזבים או להזין מחירים כוזבים במכוון;</li>
      <li>להעלות תוכן פוגעני, מאיים, משמיץ, מטעה או מפר זכויות.</li>
    </ul>

    <h2>7. קניין רוחני</h2>
    <p>
      עיצוב האתר, הקוד, הממשק, הלוגו והתוכן שנוצר על ידי המפעיל שייכים למפעיל. מידע על מוצרים, תמונותיהם ושמותיהם שייכים
      לחנויות, ליצרנים או לבעלי הזכויות בהם. מותר להשתמש באתר לשימוש אישי ולא מסחרי בלבד.
      בעל זכויות שסבור שתוכן באתר מפר את זכויותיו מוזמן לפנות אלינו (סעיף 12), ונטפל בפנייה בהקדם.
    </p>

    <h2>8. קישורים לאתרים אחרים</h2>
    <p>
      האתר כולל קישורים לאתרי החנויות (למשל "מעבר למוצר") ושיתוף בוואטסאפ. אתרים ושירותים אלה אינם בשליטת המפעיל,
      והשימוש בהם כפוף לתנאים ולמדיניות הפרטיות שלהם. המפעיל אינו אחראי לתוכנם, לזמינותם או לעסקאות שנעשות בהם.
    </p>

    <h2>9. זמינות השירות ושינויים</h2>
    <p>
      המפעיל רשאי בכל עת לשנות את האתר, להוסיף או להסיר חנויות, תכנים ושירותים, להפסיק את השירות באופן זמני או קבוע,
      ולבצע תחזוקה - בלי הודעה מוקדמת ובלי שתהיה למשתמש טענה בעניין זה. האתר אינו מתחייב לפעול ללא תקלות או הפסקות.
    </p>

    {/* <h2>10. שיפוי</h2>
    <p>
      המשתמש מתחייב לשפות את המפעיל בגין כל נזק, הוצאה או תביעה (כולל שכר טרחת עורך דין) שייגרמו לו עקב הפרת תנאים אלה
      על ידי המשתמש או עקב תוכן שהמשתמש העלה.
    </p> */}

    <h2>10. שינוי התנאים</h2>
    <p>
      המפעיל רשאי לעדכן תנאים אלה מעת לעת. מועד העדכון האחרון מופיע בראש העמוד. בשינוי מהותי, משתמשים רשומים יתבקשו לאשר את
      התנאים המעודכנים בכניסה הבאה לאתר. המשך השימוש באתר לאחר העדכון מהווה הסכמה לתנאים המעודכנים.
    </p>

    <h2>11. דין, סמכות שיפוט ויצירת קשר</h2>
    <p>
      11.1. על תנאים אלה ועל השימוש באתר יחולו דיני מדינת ישראל בלבד. סמכות השיפוט הבלעדית בכל עניין הנוגע לאתר תהיה
      לבתי המשפט המוסמכים במחוז מרכז.
    </p>
    <p>11.2. אם ייקבע שסעיף כלשהו בתנאים אינו תקף, יתר הסעיפים ימשיכו לחול.</p>
    <p>
      11.3. לשאלות, בקשות ותלונות: שלחו לנו פידבק בתחתית האתר.
    </p>
  </>
);

export default TermsOfUse;
